/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs */

const en_keyword_optimizer_generate_cta_upgrade_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to unlock →`)
};

const de_keyword_optimizer_generate_cta_upgrade_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade zum Freischalten →`)
};

const fr_keyword_optimizer_generate_cta_upgrade_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquer →`)
};

const es_keyword_optimizer_generate_cta_upgrade_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejora tu plan →`)
};

const it_keyword_optimizer_generate_cta_upgrade_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna per sbloccare →`)
};

const nl_keyword_optimizer_generate_cta_upgrade_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgraden om te ontgrendelen →`)
};

const pl_keyword_optimizer_generate_cta_upgrade_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulepsz, aby odblokować →`)
};

const fi_keyword_optimizer_generate_cta_upgrade_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä avataksesi →`)
};

const da_keyword_optimizer_generate_cta_upgrade_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader for at låse op →`)
};

const sv_keyword_optimizer_generate_cta_upgrade_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera för att låsa upp →`)
};

/**
* | output |
* | --- |
* | "Upgrade to unlock →" |
*
* @param {Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_generate_cta_upgrade_button = /** @type {((inputs?: Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Generate_Cta_Upgrade_ButtonInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_generate_cta_upgrade_button(inputs)
	if (locale === "fr") return fr_keyword_optimizer_generate_cta_upgrade_button(inputs)
	if (locale === "es") return es_keyword_optimizer_generate_cta_upgrade_button(inputs)
	if (locale === "it") return it_keyword_optimizer_generate_cta_upgrade_button(inputs)
	if (locale === "nl") return nl_keyword_optimizer_generate_cta_upgrade_button(inputs)
	if (locale === "pl") return pl_keyword_optimizer_generate_cta_upgrade_button(inputs)
	if (locale === "fi") return fi_keyword_optimizer_generate_cta_upgrade_button(inputs)
	if (locale === "da") return da_keyword_optimizer_generate_cta_upgrade_button(inputs)
	if (locale === "sv") return sv_keyword_optimizer_generate_cta_upgrade_button(inputs)
	return en_keyword_optimizer_generate_cta_upgrade_button(inputs)
});